const hsdata2022 =[
  {
    "Website": "https://iitgn.ac.in/",
    "Roll": "18BEC006",
    "Name": "Ambika Lakhera",
    "College": "EE, IIT, Gandhinagar",
    "Admission": "Gate"
  },
  {
    "Website": "https://www.ncsu.edu/",
    "Roll": "18BEC007",
    "Name": "Amita Mohta",
    "College": "Computer Eng., NC State Univeristy",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.cestarcollege.com/",
    "Roll": "18BEC024",
    "Name": "Dave Kanan Prashantkumar",
    "College": "Ai And Ml, Lambton College ",
    "Admission": "Ielts"
  },
  {
    "Website": "https://www.asu.edu/",
    "Roll": "18BEC029",
    "Name": "Eshan Saraogi",
    "College": "EE, Arizona State University",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.asu.edu/",
    "Roll": "18BEC032",
    "Name": "Kavan Gujarathi",
    "College": "EE, Arizona State University",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.ncsu.edu/",
    "Roll": "18BEC036",
    "Name": "Harshvadan Mihir",
    "College": "Computer Eng., NC State Univeristy",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.rit.edu/",
    "Roll": "18BEC038",
    "Name": "Helly Mehul Champaneri",
    "College": "Cse, Rochester Institute Of Technology",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.asu.edu/",
    "Roll": "18BEC040",
    "Name": "Ishan Gupta",
    "College": "EE, Arizona State University",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.nmims.edu/",
    "Roll": "18BEC046",
    "Name": "Sanika Mandar Joshi",
    "College": "MBA, Narsee Monjee, Mumbai",
    "Admission": "Nmims"
  },
  {
    "Website": "null",
    "Roll": "18BEC056",
    "Name": "Vimoli Harshal Mehta ",
    "College": "Information Studies, University Of Texas, Austin",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.usc.edu/",
    "Roll": "18BEC072",
    "Name": "Daxal Girishbhai Patel",
    "College": "CE, Uniersity Of Southern Californiya",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.asu.edu/",
    "Roll": "18BEC107",
    "Name": "Siddhant Gaurav Patel",
    "College": "CSE, Arizona State University",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.ncsu.edu/",
    "Roll": "18BEC115",
    "Name": "Riya Tanna",
    "College": "Computer Eng., NC State Univeristy",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.utexas.edu/",
    "Roll": "18BEC118",
    "Name": "Toshita Sharma",
    "College": "Information Studies, University Of Texas, Austin",
    "Admission": "Toefel"
  },
  {
    "Website": "https://engineering.nyu.edu/",
    "Roll": "18BEC119",
    "Name": "Dehit Hitendra Trivedi",
    "College": "Ee, Tondon School Of Eng., New York University",
    "Admission": "Gre"
  },
  {
    "Website": "https://www.ncsu.edu/",
    "Roll": "18BEC122",
    "Name": "Vincent Abraham",
    "College": "Computer Eng., NC State Univeristy",
    "Admission": "Gre"
  }
]
export default hsdata2022;